export enum VerificationSchemaView {
  General = "general",
  ScreeningServices = "screening_services",
  MilitaryOrTeacher = "military_first_responder_teacher",
  AdditionalQuestions = "Additional Questions",
  TenantQualifications = "terms_and_conditions",
  SubmissionDisclosure = "submission_disclosure",
  DecisionCriteria = "Decision criteria",
  LeadSource = "lead_source",
  PersonalDetails = "personal_details",
  Dependents = "dependents",
  EmergencyContacts = "emergency_contacts",
  Pets = "pets",
  Vehicles = "vehicles",
  MilitaryFirstResponderTeacher = "military_first_responder_teacher",
  BasicInformation = "rental_application",
  IdentityVerification = "identity_verification",
  IncomeHistory = "verified_income_verification",
  CombinedIncomeVerification = "combined_income_verification",
  HousingHistory = "housing_history",
  CreditReport = "credit_report",
  CriminalReport = "criminal_report",
  HousingCourtReport = "eviction_report",
  // Verified Income
  DocumentVerification = "document_verification",
  BankVerification = "bank_verification",
  PayrollVerification = "payroll_verification",
  // Income
  Employment = "employment",
  SelfEmployed = "self_employed",
  OfferLetter = "offer_letter",
  OtherIncome = "other_income",
  HousingAssistance = "housing_assistance",
  // Combined Income
  CombinedEmployment = "combined_employment",
  CombinedSelfEmployed = "combined_self_employed",
  CombinedOfferLetter = "combined_offer_letter",
  CombinedOtherIncome = "combined_other_income",
  CombinedHousingAssistance = "combined_housing_assistance",
  // Housing configuration
  RentVerification = "rent",
  OwnVerification = "own_home",
  OtherVerification = "other",
  GeneralHousingConfiguration = "general_housing_configuration",
  //
  CountyWalkIn = "county_walk_in",
  CountyWalkInAutomatic = "county_walk_in_automatic",
  CountyWalkInManual = "county_walk_in_manual",
  AdverseAction = "adverse_action",
  AdverseActionGenericTemplate = "adverse_action_template",
  AdverseActionWATemplate = "adverse_action_wa_template",
  DiscountCodes = "discount_codes",
  PetScreeningReport = "pet_screening_report"
}
